// @ts-nocheck
import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/css';
import SplitText from "../components/splitText";


export const page = async () => {
    const homeSwiper = new Swiper('.swiperotherRecipes', {
        modules: [Pagination],
        slidesPerView: 1,
        spaceBetween: 30,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 30,
                pagination: false,
            },
        }
    })

    animationSplit()
}

function animationSplit(){
    new SplitText(".mxmhRecipes__content--top--title")
    new SplitText(".mxmhRecipes__content--ingredients--title")
    new SplitText(".mxmhRecipes__content--steps--title")
    new SplitText(".mxmhRecipes__content--other--title")
}
